export abstract class Participation {
  firstName: string;
  hasLodgingToShare?: boolean;
  isMatmutCustomer?: boolean;
  lastName: string;
  mail: string;
  phone: string;
  resumeFileId: string;
  rightsConsent: boolean;
  sourcePlatform = "WIZBII - Formulaire d'inscription";
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  utmTerm?: string;
  utmContent?: string;
  educationLevel?: string;
  jobId?: string;
  jobDomain?: string;
  experienceYears?: number;
  driverLicence?: boolean;
  motivations?: string;

  protected constructor(data = {}) {
    this.firstName = data['firstName'];
    this.hasLodgingToShare = data['hasLodgingToShare'];
    this.isMatmutCustomer = data['isMatmutCustomer'];
    this.lastName = data['lastName'];
    this.mail = data['mail'];
    this.phone = data['phone'];
    this.resumeFileId = data['resumeFileId'];
    this.rightsConsent = data['rightsConsent'];
    this.utmSource = data['utmSource'];
    this.utmMedium = data['utmMedium'];
    this.utmCampaign = data['utmCampaign'];
    this.utmTerm = data['utmTerm'];
    this.utmContent = data['utmContent'];
    this.educationLevel = data['educationLevel'];
    this.jobId = data['jobId'];
    this.jobDomain = data['jobDomain'];
    this.experienceYears = data['experienceYears'];
    this.driverLicence = data['driverLicence'];
    this.motivations = data['motivations'];
  }
}

export interface AdditionnalParticipation {
  educationLevel?: string;
  jobId?: string;
  jobDomain?: string;
  experienceYears?: number;
  driverLicence?: boolean;
  motivations?: string;
}
